import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap'; 

const MyNavbar = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <Navbar variant="light" expand="lg">
      <Container>
    
        <Navbar.Toggle aria-controls="navbar-nav" onClick={toggleMenu} />

        <Navbar.Collapse id="navbar-nav" in={isMenuOpen}>
          <Nav className="ml-auto">
            <Nav.Link as={Link} to="/" onClick={closeMenu}>Home</Nav.Link>
            <Nav.Link as={Link} to="/experience" onClick={closeMenu}>Experience</Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={closeMenu}>About Me</Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={closeMenu}>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MyNavbar;
